<div class="report row mx-md-0 px-md-0">
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Commission Earned:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.commissionEarned | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Commission Rate:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.commissionRateUsed }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-2 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-3 d-flex justify-content-start">
        <span class="">Client:</span>
      </div>
      <div class="col-9 d-flex justify-content-start font-weight-bold mx-0 px-0">
        <span class="itemCreated">
          {{ itm.customerName }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-3 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Client's Phone:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.customerPhone1 }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-4 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Date Earned:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.dateEarned }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-5 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Loan ID:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.loanId }}
        </span>
      </div>
    </div>
  </div>
  <div class="field col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Int + Loan Paid:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.loanInterestPaid | number }}
        </span>
      </div>
    </div>
  </div>
  <div class="field-1 col-12 col-md-6 col-xl-4">
    <div class="row">
      <div class="col-5 d-flex justify-content-start">
        <span class="">Time Earned:</span>
      </div>
      <div class="col-7 d-flex justify-content-start font-weight-bold">
        <span class="itemCreated">
          {{ itm.timeEarned }}
        </span>
      </div>
    </div>
  </div>
</div>
